import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'saeculum-form-validation-message',
  templateUrl: './form-validation-message.component.html',
  styleUrls: ['./form-validation-message.component.css']
})
export class FormValidationMessageComponent implements OnInit {
  @Input() fieldObj: any;
  @Input() form: FormGroup;
  constructor() { }

  ngOnInit() {
  }

}
